/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OperatingAreaDto
 */
export interface OperatingAreaDto {
    /**
     * Operating area ID
     * @type {number}
     * @memberof OperatingAreaDto
     */
    id: number;
    /**
     * Supplier organization ID
     * @type {number}
     * @memberof OperatingAreaDto
     */
    organizationId: number;
    /**
     * Country code (ISO 3166-1 alpha-3)
     * @type {string}
     * @memberof OperatingAreaDto
     */
    countryCode: string;
    /**
     * Admin area 1 code (province/state)
     * @type {string}
     * @memberof OperatingAreaDto
     */
    adminArea1Code: string | null;
    /**
     * Admin area 2 code (city/district)
     * @type {string}
     * @memberof OperatingAreaDto
     */
    adminArea2Code: string | null;
    /**
     * Timestamp created at
     * @type {Date}
     * @memberof OperatingAreaDto
     */
    createdAt: Date;
    /**
     * Timestamp updated at
     * @type {Date}
     * @memberof OperatingAreaDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the OperatingAreaDto interface.
 */
export function instanceOfOperatingAreaDto(value: object): value is OperatingAreaDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('adminArea1Code' in value) || value['adminArea1Code'] === undefined) return false;
    if (!('adminArea2Code' in value) || value['adminArea2Code'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function OperatingAreaDtoFromJSON(json: any): OperatingAreaDto {
    return OperatingAreaDtoFromJSONTyped(json, false);
}

export function OperatingAreaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperatingAreaDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationId': json['organizationId'],
        'countryCode': json['countryCode'],
        'adminArea1Code': json['adminArea1Code'],
        'adminArea2Code': json['adminArea2Code'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function OperatingAreaDtoToJSON(value?: OperatingAreaDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'organizationId': value['organizationId'],
        'countryCode': value['countryCode'],
        'adminArea1Code': value['adminArea1Code'],
        'adminArea2Code': value['adminArea2Code'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

